import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('systemPropertyCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/system/properties'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.systemProperties,
    cacheName: 'systemProperties'
  })
);
